/**
 * Created by chenzheyu on 2017/7/3.
 */
import XkCouponNav from './src/couponNav.vue'

XkCouponNav.install = function (Vue) {
  Vue.component(XkCouponNav.name, XkCouponNav)
}

export default XkCouponNav



// WEBPACK FOOTER //
// ./src/components/module/couponNav/index.js